module.exports = __webpack_public_path__ + "static/media/amp.dd852996.svg";